import 'babel-polyfill';
import initQtyInput from '../qtyInput';
import Popup from '../Popup';
import axios from 'axios';


import { mapState, mapActions } from 'vuex';
import store from '../store';
import cartItemListMixin from '../vue_mixins/cartItemListMixin';
import i18n from "../vue_i18n";

$(document).ready(function() {

    //qty input
    initQtyInput();
    //ask excel popups
    window.popups.askExcelOrderPopup = new Popup($('#ask-excel-order-popup'));

});

window.vm.shoppingCartVm = new Vue({
    el: '#shopping-cart-container',
    store,
    i18n,
    mixins: [cartItemListMixin],
    data: {
        baseUrl: window.baseUrl,
    },
    computed: {
        isContainWine() {
            const orderItems = this.sessionOrder.order_items;
            let isWine = false;
            orderItems.forEach(({product_id}) => {
                if(!isWine) {
                    const product = this.products[product_id];
                    if(product.is_wine) {
                        isWine = true;
                    }
                }
            });
            return isWine;
        },
    },
    methods: {
        confirmWineWarningPopup(cb) {
            sessionStorage.setItem('isWineWarningShowed', true);
            cb();
        },
        nextBtnOnClick: function(e) {
            const task = 'redirecting';
            if(sessionStorage.getItem("isWineWarningShowed") !== 'true' && this.isContainWine) {
                window.popups.wineWarningPopup.openPopup();
                e.preventDefault();
                const url = $(e.target).closest('a').attr('href');
                window.popups.wineWarningPopup.popup.find('button.btn-confirm').on('click', (e) => {
                    this.confirmWineWarningPopup(() => {
                        this.$store.dispatch('addLoadingTask', {task});
                        window.location.href = url;
                    })
                });
            }else {
                this.$store.dispatch('addLoadingTask', {task});
            }
        },
    },
    created() {
        window.popups.wineWarningPopup = new Popup($('#wine-warning-popup'));
        window.popups.wineWarningPopup.popup.find('button').on('click', () => {
            window.popups.wineWarningPopup.closePopup();
        });

    }
});
